import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import AuthLayout from "./AuthLayout";
import { Button } from "../components/kit";
import { useAuth } from "../context/AuthContext";
import api, { formatApiErrorDetail, TIMEZONE } from "../lib/api";

export default function TeamJoin() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const { user, setUser, refreshUser } = useAuth();
  const navigate = useNavigate();
  const [info, setInfo] = useState(null);
  const [error, setError] = useState("");
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get(`/team/invite/${encodeURIComponent(token)}`).then((r) => setInfo(r.data)).catch((e) => setError(formatApiErrorDetail(e.response?.data?.detail)));
  }, [token]);

  const run = async (fn) => {
    setBusy(true); setError("");
    try { await fn(); navigate("/coach"); } catch (e) { setError(formatApiErrorDetail(e.response?.data?.detail)); } finally { setBusy(false); }
  };
  const acceptExisting = () => run(async () => { await api.post("/team/accept", { token }); await refreshUser(); });
  const acceptNew = (e) => { e.preventDefault(); run(async () => { const { data } = await api.post("/team/accept-new", { token, name, password, timezone: TIMEZONE }); setUser(data); }); };
  const next = `/team/join?token=${encodeURIComponent(token)}`;

  return (
    <AuthLayout title="Join a coaching team" subtitle={info ? `${info.owner_name || "A coach"} invited you to ${info.program_name || "their program"} on Catalyst.` : "Checking your invite…"} testId="team-join-page">
      {error && <div data-testid="team-join-error" style={errStyle}>{error}</div>}
      {info && user && (
        user.email === info.email ? (
          <Button full size="lg" data-testid="team-join-accept" disabled={busy} onClick={acceptExisting}>{busy ? "Joining…" : "Accept invite"}</Button>
        ) : (
          <p style={note}>You're signed in as a different account. Sign out, then open this link again as <b>{info.email}</b>.</p>
        )
      )}
      {info && user === false && info.account_exists && (
        <Button full size="lg" data-testid="team-join-signin" onClick={() => navigate(`/login?next=${encodeURIComponent(next)}`)}>Sign in as {info.email} to accept</Button>
      )}
      {info && user === false && !info.account_exists && (
        <form onSubmit={acceptNew} style={{ display: "flex", flexDirection: "column", gap: "var(--space-4)" }}>
          <label style={lbl}>Email<input className="buktu-input" value={info.email} disabled data-testid="team-join-email" /></label>
          <label style={lbl}>Your name<input className="buktu-input" data-testid="team-join-name" value={name} onChange={(e) => setName(e.target.value)} required /></label>
          <label style={lbl}>Create a password<input className="buktu-input" type="password" minLength={6} data-testid="team-join-password" value={password} onChange={(e) => setPassword(e.target.value)} required placeholder="At least 6 characters" /></label>
          <Button type="submit" full size="lg" data-testid="team-join-create" disabled={busy}>{busy ? "Creating account…" : "Create account & join"}</Button>
        </form>
      )}
      <p style={{ ...note, textAlign: "center", marginTop: "var(--space-4)" }}><Link to="/" style={{ color: "var(--text-link)" }}>Back to Buktu</Link></p>
    </AuthLayout>
  );
}

const lbl = { display: "flex", flexDirection: "column", gap: "var(--space-2)", font: "var(--type-label)", color: "var(--text-strong)" };
const note = { font: "var(--type-body-sm)", fontSize: 13, color: "var(--text-muted)" };
const errStyle = { padding: "var(--space-3) var(--space-4)", borderRadius: "var(--radius-md)", background: "var(--status-risk-soft)", color: "#8a2a1a", font: "var(--type-body-sm)", fontSize: 13, marginBottom: "var(--space-4)" };
